'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UserOverride = require('./userOverride');
var TaskTemplate = require('./taskTemplate');
var Task = require('./task');
var SaleType = require('./saleType');
var Relation = require('./relation');
var Proforma = require('./proforma');
var Partner = require('./partner');
var NotaryClerk = require('./notaryClerk');
var Notary = require('./notary');
var Movement = require('./movement');
var Invoice = require('./invoice');
var DossierDisabledUserOverride = require('./dossierDisabledUserOverride');
var DefaultCommissioningRules = require('./defaultCommissioningRules');
var CommissionScaleTemplate = require('./commissionScaleTemplate');
var BankAccount = require('./bankAccount');
var Actor = require('./actor');
var Classeur = require('./classeur');
var CommissionData = require('./commissionData');
var CommissionScale = require('./commissionScale');
var CommissioningRules = require('./commissioningRules');
var Dispute = require('./dispute');
var Dossier = require('./dossier');
var Exception = require('./exception');
var ManualCommissionData = require('./manualCommissionData');
var PartnerScale = require('./partnerScale');
var Reminder = require('./reminder');
var ThirdPartyInvoice = require('./thirdPartyInvoice');
var ThirdPartyInvoiceTemplate = require('./thirdPartyInvoiceTemplate');
var Metric = require('./metric');
var ProformaTemplate = require('./proformaTemplate');
var Netexplorer = require('./netexplorer');
var TaskCategory = require('./taskCategory');

/**
* @class CommissionServiceApi
*/
var CommissionServiceApi = /*#__PURE__*/function () {
  function CommissionServiceApi(http) {
    _classCallCheck(this, CommissionServiceApi);
    var commissionClient = http.extend({
      serviceName: "commission"
    });
    this._userOverride = new UserOverride(commissionClient);
    this._taskTemplate = new TaskTemplate(commissionClient);
    this._task = new Task(commissionClient);
    this._saleType = new SaleType(commissionClient);
    this._relation = new Relation(commissionClient);
    this._proforma = new Proforma(commissionClient);
    this._partner = new Partner(commissionClient);
    this._notaryClerk = new NotaryClerk(commissionClient);
    this._notary = new Notary(commissionClient);
    this._movement = new Movement(commissionClient);
    this._invoice = new Invoice(commissionClient);
    this._dossierDisabledUserOverride = new DossierDisabledUserOverride(commissionClient);
    this._defaultCommissioningRules = new DefaultCommissioningRules(commissionClient);
    this._commissionScaleTemplate = new CommissionScaleTemplate(commissionClient);
    this._bankAccount = new BankAccount(commissionClient);
    this._actor = new Actor(commissionClient);
    this._classeur = new Classeur(commissionClient);
    this._commissionData = new CommissionData(commissionClient);
    this._commissionScale = new CommissionScale(commissionClient);
    this._commissioningRules = new CommissioningRules(commissionClient);
    this._dispute = new Dispute(commissionClient);
    this._dossier = new Dossier(commissionClient);
    this._exception = new Exception(commissionClient);
    this._manualCommissionData = new ManualCommissionData(commissionClient);
    this._partnerScale = new PartnerScale(commissionClient);
    this._reminder = new Reminder(commissionClient);
    this._thirdPartyInvoice = new ThirdPartyInvoice(commissionClient);
    this._thirdPartyInvoiceTemplate = new ThirdPartyInvoiceTemplate(commissionClient);
    this._metric = new Metric(commissionClient);
    this._proformaTemplate = new ProformaTemplate(commissionClient);
    this._netexplorer = new Netexplorer(commissionClient);
    this._taskCategory = new TaskCategory(commissionClient);
  }
  return _createClass(CommissionServiceApi, [{
    key: "setHttp",
    value: function setHttp(http) {
      this._userOverride.setHttp(http);
      this._taskTemplate.setHttp(http);
      this._task.setHttp(http);
      this._saleType.setHttp(http);
      this._relation.setHttp(http);
      this._proforma.setHttp(http);
      this._partner.setHttp(http);
      this._notaryClerk.setHttp(http);
      this._notary.setHttp(http);
      this._movement.setHttp(http);
      this._invoice.setHttp(http);
      this._dossierDisabledUserOverride.setHttp(http);
      this._defaultCommissioningRules.setHttp(http);
      this._commissionScaleTemplate.setHttp(http);
      this._bankAccount.setHttp(http);
      this._actor.setHttp(http);
      this._classeur.setHttp(http);
      this._commissionData.setHttp(http);
      this._commissionScale.setHttp(http);
      this._commissioningRules.setHttp(http);
      this._dispute.setHttp(http);
      this._dossier.setHttp(http);
      this._exception.setHttp(http);
      this._manualCommissionData.setHttp(http);
      this._partnerScale.setHttp(http);
      this._reminder.setHttp(http);
      this._thirdPartyInvoice.setHttp(http);
      this._thirdPartyInvoiceTemplate.setHttp(http);
      this._metric.setHttp(http);
      this._proformaTemplate.setHttp(http);
      this._netexplorer.setHttp(http);
      this._taskCategory.setHttp(http);
    }

    /**
    *
    * userOverride
    *
    *  @returns { CommissionUserOverrideModel }
    */
  }, {
    key: "userOverride",
    get: function get() {
      return this._userOverride;
    }

    /**
    *
    * taskTemplate
    *
    *  @returns { CommissionTaskTemplateModel }
    */
  }, {
    key: "taskTemplate",
    get: function get() {
      return this._taskTemplate;
    }

    /**
    *
    * task
    *
    *  @returns { CommissionTaskModel }
    */
  }, {
    key: "task",
    get: function get() {
      return this._task;
    }

    /**
    *
    * saleType
    *
    *  @returns { CommissionSaleTypeModel }
    */
  }, {
    key: "saleType",
    get: function get() {
      return this._saleType;
    }

    /**
    *
    * relation
    *
    *  @returns { CommissionRelationModel }
    */
  }, {
    key: "relation",
    get: function get() {
      return this._relation;
    }

    /**
    *
    * proforma
    *
    *  @returns { CommissionProformaModel }
    */
  }, {
    key: "proforma",
    get: function get() {
      return this._proforma;
    }

    /**
    *
    * partner
    *
    *  @returns { CommissionPartnerModel }
    */
  }, {
    key: "partner",
    get: function get() {
      return this._partner;
    }

    /**
    *
    * notaryClerk
    *
    *  @returns { CommissionNotaryClerkModel }
    */
  }, {
    key: "notaryClerk",
    get: function get() {
      return this._notaryClerk;
    }

    /**
    *
    * notary
    *
    *  @returns { CommissionNotaryModel }
    */
  }, {
    key: "notary",
    get: function get() {
      return this._notary;
    }

    /**
    *
    * movement
    *
    *  @returns { CommissionMovementModel }
    */
  }, {
    key: "movement",
    get: function get() {
      return this._movement;
    }

    /**
    *
    * invoice
    *
    *  @returns { CommissionInvoiceModel }
    */
  }, {
    key: "invoice",
    get: function get() {
      return this._invoice;
    }

    /**
    *
    * dossierDisabledUserOverride
    *
    *  @returns { CommissionDossierDisabledUserOverrideModel }
    */
  }, {
    key: "dossierDisabledUserOverride",
    get: function get() {
      return this._dossierDisabledUserOverride;
    }

    /**
    *
    * defaultCommissioningRules
    *
    *  @returns { CommissionDefaultCommissioningRulesModel }
    */
  }, {
    key: "defaultCommissioningRules",
    get: function get() {
      return this._defaultCommissioningRules;
    }

    /**
    *
    * commissionScaleTemplate
    *
    *  @returns { CommissionCommissionScaleTemplateModel }
    */
  }, {
    key: "commissionScaleTemplate",
    get: function get() {
      return this._commissionScaleTemplate;
    }

    /**
    *
    * bankAccount
    *
    *  @returns { CommissionBankAccountModel }
    */
  }, {
    key: "bankAccount",
    get: function get() {
      return this._bankAccount;
    }

    /**
    *
    * actor
    *
    *  @returns { CommissionActorModel }
    */
  }, {
    key: "actor",
    get: function get() {
      return this._actor;
    }

    /**
    *
    * classeur
    *
    *  @returns { CommissionClasseurModel }
    */
  }, {
    key: "classeur",
    get: function get() {
      return this._classeur;
    }

    /**
    *
    * commissionData
    *
    *  @returns { CommissionCommissionDataModel }
    */
  }, {
    key: "commissionData",
    get: function get() {
      return this._commissionData;
    }

    /**
    *
    * commissionScale
    *
    *  @returns { CommissionCommissionScaleModel }
    */
  }, {
    key: "commissionScale",
    get: function get() {
      return this._commissionScale;
    }

    /**
    *
    * commissioningRules
    *
    *  @returns { CommissionCommissioningRulesModel }
    */
  }, {
    key: "commissioningRules",
    get: function get() {
      return this._commissioningRules;
    }

    /**
    *
    * dispute
    *
    *  @returns { CommissionDisputeModel }
    */
  }, {
    key: "dispute",
    get: function get() {
      return this._dispute;
    }

    /**
    *
    * dossier
    *
    *  @returns { CommissionDossierModel }
    */
  }, {
    key: "dossier",
    get: function get() {
      return this._dossier;
    }

    /**
    *
    * exception
    *
    *  @returns { CommissionExceptionModel }
    */
  }, {
    key: "exception",
    get: function get() {
      return this._exception;
    }

    /**
    *
    * manualCommissionData
    *
    *  @returns { CommissionManualCommissionDataModel }
    */
  }, {
    key: "manualCommissionData",
    get: function get() {
      return this._manualCommissionData;
    }

    /**
    *
    * partnerScale
    *
    *  @returns { CommissionPartnerScaleModel }
    */
  }, {
    key: "partnerScale",
    get: function get() {
      return this._partnerScale;
    }

    /**
    *
    * reminder
    *
    *  @returns { CommissionReminderModel }
    */
  }, {
    key: "reminder",
    get: function get() {
      return this._reminder;
    }

    /**
    *
    * thirdPartyInvoice
    *
    *  @returns { CommissionThirdPartyInvoiceModel }
    */
  }, {
    key: "thirdPartyInvoice",
    get: function get() {
      return this._thirdPartyInvoice;
    }

    /**
    *
    * thirdPartyInvoiceTemplate
    *
    *  @returns { CommissionThirdPartyInvoiceTemplateModel }
    */
  }, {
    key: "thirdPartyInvoiceTemplate",
    get: function get() {
      return this._thirdPartyInvoiceTemplate;
    }

    /**
    *
    * metric
    *
    *  @returns { CommissionMetricModel }
    */
  }, {
    key: "metric",
    get: function get() {
      return this._metric;
    }

    /**
    *
    * proformaTemplate
    *
    *  @returns { CommissionProformaTemplateModel }
    */
  }, {
    key: "proformaTemplate",
    get: function get() {
      return this._proformaTemplate;
    }

    /**
    *
    * netexplorer
    *
    *  @returns { CommissionNetexplorerModel }
    */
  }, {
    key: "netexplorer",
    get: function get() {
      return this._netexplorer;
    }

    /**
    *
    * taskCategory
    *
    *  @returns { CommissionTaskCategoryModel }
    */
  }, {
    key: "taskCategory",
    get: function get() {
      return this._taskCategory;
    }
  }]);
}();
module.exports = CommissionServiceApi;